import { quoteAboutText } from "i18n/about";
import React from "react";
import { useSelector } from "react-redux";

const Quote = () => {
  const lang = useSelector((state) => state.language.lang);
  const t = quoteAboutText[lang];
  return (
    <section className="bg-black py-16 px-6">
      <div className=" mx-auto border border-white/70 px-6 md:px-16 py-14 md:py-20 text-center">
        {/* Main Quote */}
        <div className="max-w-5xl mx-auto">
          <h2
            className="  text-white font-semibold leading-tight
                       text-2xl sm:text-3xl md:text-4xl lg:text-3xl font-[Crimson] "
          >
            {t.title.split("growth").length > 1 ? (
              <>
                {t.title.split("growth")[0]}
                <span className="font-bold uppercase">growth</span>
                {t.title.split("growth")[1]}
              </>
            ) : (
              t.title
            )}
          </h2>

          <p
            className="mt-8 text-white/90
                      text-base sm:text-lg md:text-xl
                      leading-relaxed max-w-3xl mx-auto"
          >
            {t.body}
          </p>

          {/* <div className="mt-12 flex justify-center">
            <img
              src="/images/signature.png"
              alt="Signature"
              className="w-40 md:w-56 object-contain"
            />
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default Quote;
